import React from 'react'
import './style.css'
import Button from '../../CtaButton';
import AuraButtonGreen from '../AuraButton/AuraButtonGreen';

const AuraWhyUs = () => {

    const content = [
        {
            icon: '/images/aura-clinic-icons/circle-icon-6.svg',
            title: 'Smart, Paperless Onboarding',
            description: 'Aura Clinic eliminates traditional paperwork through fully digital forms, automated data capture, and instant record creation. Patients complete their details in minutes, and clinics reduce manual errors while speeding up intake and check-in.'
        },
        {
            icon: '/images/aura-clinic-icons/circle-icon-5.svg',
            title: 'AI-Assisted Clinical Workflow Automation',
            description: 'From triage suggestions to pre-visit summaries, Aura uses intelligent automation to reduce repetitive tasks. This keeps clinics running efficiently during peak hours and gives practitioners more time to focus on patient care rather than admin work.'
        },
        {
            icon: '/images/aura-clinic-icons/circle-icon-4.svg',
            title: 'Unified, Real-Time Patient Data',
            description: 'All patient information medical history, forms, signatures, and notes is automatically organized and securely stored in one place. Aura Clinic standardizes data across the entire workflow, enabling faster decision-making, clearer collaboration, and increased accuracy.'
        },
        {
            icon: '/images/aura-clinic-icons/circle-icon-3.svg',
            title: 'Compliance-Ready & Secure by Design',
            description: 'With encrypted data handling, digital consent flows, permission-based access, and HIPAA-aligned standards, Aura Clinic ensures clinics operate safely and confidently. Every action is traceable, audit-ready, and built for long-term trust.'
        },
        {
            icon: '/images/aura-clinic-icons/circle-icon-2.svg',
            title: 'Faster Operations & Reduced Admin Load',
            description: 'Automation reduces manual tasks by up to 70%, lowering staff workload and freeing up time for higher-value clinical duties. Faster workflows mean shorter waiting times, smoother days, and improved clinic efficiency overall.'
        },
        {
            icon: '/images/aura-clinic-icons/circle-icon-1.svg',
            title: 'Enhanced Patient Experience',
            description: 'Patients appreciate clarity, speed, and transparency. Aura Clinic delivers all three less waiting, easy digital interactions, and consistent communication leading to higher satisfaction and better patient engagement.'
        }
    ];

    return (
        <>
            <section className="aura-clinic-why-us-section">
                <div className="container">
                    <div className="row mb-4">
                        <div className="col-md-12">
                            <h2 className="aura-clinic-heading">Why Clinics Choose Aura Clinic</h2>
                            <p className="description-text">
                                Aura Clinic is redefining how clinics operate by turning time-consuming, paper-heavy processes into seamless, digital, patient-first experiences.
                            </p>
                        </div>
                    </div>

                    <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                        {content.map((item, index) => (
                            <div key={index} className="aura-clinic-col">
                                <div className="aura-clinic-card text-center">
                                    <div className="aura-clinic-card-body">
                                        <img src={item.icon} width={40} className='mb-3' alt="Aura Why Us Icons" />
                                        <h5 className="aura-clinic-card-title">{item.title}</h5>
                                        <p className="description-text mb-3">{item.description}</p>
                                        {/* <AuraButtonGreen text='Learn More' link='#' /> */}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default AuraWhyUs